/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

// tslint:disable:variable-name

import { DirtyType } from '@gh/common-shared-data';
import { arrayOf, date, DateFormat, entity, enumeration, subentity } from '@gh/core-data';

import { ContactDeliveryMethod } from '../contacts';
import {
  QuotationBase,
  QuotationDetailsInitResponseDto,
  QuotationDetailsSaveRequestDto,
  QuotationDto, QuotationListItemDto,
  QuotationRfqNumberDto,
  QuotationsGetResponseDto,
  QuotationStructureSaveRequestDto,
  QuotationVariationDto,
  QuoteStructureItemDto,
  QuoteStructureRequestDto,
  QuoteStructureResponseDto,
} from './quotation.dto';
import { SalesFolderStatus } from './sales-folder.dto';
import { LeadListFilter, LeadListItemDto } from './lead.dto';

export const QuotationVariationMapper = entity<QuotationVariationDto>({});

export const QuotationMapper = entity<QuotationDto>({
  date: date(DateFormat.DateTime),
  base: enumeration(QuotationBase),
  lastUpdated: date(DateFormat.DateTime),
  approvedDate: date(DateFormat.DateTime),
});

export const QuotationsGetResponseMapper = entity<QuotationsGetResponseDto>({
  quotations: arrayOf(QuotationMapper),
});

export const QuoteStructureItemMapper = entity<QuoteStructureItemDto>({});

export const QuoteStructureResponseMapper = entity<QuoteStructureResponseDto>({});
export const QuoteStructureRequestMapper = entity<QuoteStructureRequestDto>({});

export const QuoteDetailsInitReponseMapper = entity<QuotationDetailsInitResponseDto>({
  created: date(DateFormat.DateTime),
  approvedDate: date(DateFormat.DateTime),
  base: enumeration(QuotationBase),
  salesFolderStatus: enumeration(SalesFolderStatus),
  variations: arrayOf(QuotationVariationMapper),
  deliveryBy: enumeration(ContactDeliveryMethod),
});

export const QuoteDetailsSaveRequestMapper = entity<QuotationDetailsSaveRequestDto>({
  base: enumeration(QuotationBase),
  variations: arrayOf(subentity<QuotationStructureSaveRequestDto>({
    dirtyType: enumeration(DirtyType),
  })),
});

export const QuotationListFilterMapper = entity<QuotationListItemDto>();

export const QuotationRfqNumberMapper = entity<QuotationRfqNumberDto>({});

export const QuotationListItemMapper = entity<any>({});
